import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const inputStyle = {
  border: '1px solid #98A2B3',
  width: '100%',
  padding: '10px',
  borderRadius: '5px',
  marginBottom: '12px',
  color: '#000',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
  fontSize: '16px',
};

// "Add Reference Manually" dialog. Mirrors the link/note/task dialogs but with
// the three reference fields. Purely controlled — `onSave` hands the parent the
// reference object; persistence is the parent's concern.
const ReferenceModal = ({ open, handleClose, item, onSave }) => {
  const [reference, setReference] = useState('');
  const [url, setUrl] = useState('');
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (open) {
      setReference(item?.reference || '');
      setUrl(item?.url || '');
      setNotes(item?.notes || '');
    }
  }, [open, item]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = reference.trim();
    if (!trimmed) return;
    onSave({
      reference: trimmed,
      url: url.trim(),
      notes: notes.trim(),
    });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontSize: '26px', fontWeight: 700, textAlign: 'left' }}>
        {item ? 'Edit Reference Manually' : 'Add Reference Manually'}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 18, top: 18, color: '#000' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent style={{ marginTop: 10 }}>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Reference"
            value={reference}
            onChange={(e) => setReference(e.target.value)}
            style={inputStyle}
            required
            autoFocus
          />
          <input
            type="text"
            placeholder="URL / DOI"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            style={inputStyle}
          />
          <textarea
            placeholder="Notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows="8"
            style={{ ...inputStyle, resize: 'vertical' }}
          />

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: '4px' }}>
            <Button
              type="button"
              onClick={handleClose}
              style={{
                padding: '6px 18px',
                borderRadius: '5px',
                fontSize: '16px',
                border: '1px solid #356AC3',
                textTransform: 'inherit',
                color: '#356AC3',
                fontWeight: 550,
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              style={{
                backgroundColor: '#356AC3',
                color: '#FFF',
                padding: '8px 24px',
                textTransform: 'inherit',
                borderRadius: '5px',
                fontSize: '16px',
                border: 0,
                fontWeight: 550,
              }}
            >
              {item ? 'Save' : 'Add'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ReferenceModal;
